import type {AxiosError} from 'axios';
import {useMutation, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {
	validatePassword,
	type ValidatePasswordErrorResponse,
	type ValidatePasswordRequest,
	type ValidatePasswordResponse,
} from '../../http';

export function useValidatePassword(
	options?: UseMutationOptions<ValidatePasswordResponse, AxiosError<ValidatePasswordErrorResponse>, ValidatePasswordRequest>,
): UseMutationResult<ValidatePasswordResponse, AxiosError<ValidatePasswordErrorResponse>, ValidatePasswordRequest> {
	return useMutation<ValidatePasswordResponse, AxiosError<ValidatePasswordErrorResponse>, ValidatePasswordRequest>(
		(request) => validatePassword(request).then(({data}) => data),
		options,
	);
}
